import { createRouter, createWebHistory } from 'vue-router';

// Import the Home and Commands components
import Home from '../views/LandingPage.vue';
import Commands from '../views/CommandsPage.vue';
import Guides from '../views/GuidesPage.vue';
import GuideDetail from '../views/GuideDetailPage.vue';
import Changelog from '../views/ChangelogPage.vue';
import NotFound from '../views/NotFoundPage.vue';

// If a static host served 404.html first, restore the original deep link
// before router creation so initial navigation resolves correctly.
const redirectPath = new URLSearchParams(window.location.search).get('redirect');
if (redirectPath && redirectPath.startsWith('/') && !redirectPath.startsWith('//')) {
    window.history.replaceState({}, '', redirectPath);
}

const router = createRouter({
    history: createWebHistory(),
    routes: [{
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                title: 'Home'
            }
        },
        {
            path: '/commands',
            name: 'Commands',
            component: Commands,
            meta: {
                title: 'Commands'
            }
        },
        {
            path: '/guides',
            name: 'Guides',
            component: Guides,
            meta: {
                title: 'Guides'
            }
        },
        {
            path: '/guides/:slug',
            name: 'GuideDetail',
            component: GuideDetail,
            meta: {
                title: 'Guide'
            }
        },
        {
            path: '/changelog',
            name: 'Changelog',
            component: Changelog,
            meta: {
                title: 'Changelog'
            }
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: NotFound,
            meta: {
                title: '404 - Not Found'
            }
        }
    ],
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Partycord';
    next();
})

export default router;